import { TRAFFIC_SOURCE } from '../../../../server/src/constants/trafficSource'
import { TrafficSourceKey } from '../../../typings'
import { HOME_PATH } from '../../constants'

export const getContributionUserURL = (
  groupId: string,
  source?: TrafficSourceKey,
) => {
  const baseUrl = `${HOME_PATH}/${groupId}/contribute`
  return source ? `${baseUrl}?sr=${TRAFFIC_SOURCE[source]}` : baseUrl
}

export const getContributeGuestURL = (
  groupId: string,
  source?: TrafficSourceKey,
) => {
  const baseUrl = `${HOME_PATH}/${groupId}/contribute-guest`
  return source ? `${baseUrl}?sr=${TRAFFIC_SOURCE[source]}` : baseUrl
}
